import { ApolloError, useQuery } from '@apollo/client'
import { COMPANY_RANKING_SETTINGS_FOR_COUNTRY } from '../Queries'
import { CompanyRankingSettingsForCountryQuery, CompanyRankingSettingsForCountryQueryVariables, Country } from '../../../types'

export default (
  companyId: string,
  country: Country,
): {
  data: CompanyRankingSettingsForCountryQuery | undefined
  error: ApolloError | undefined
  loading: boolean
  startPolling: (pollInterval: number) => void
  stopPolling: () => void
} => {
  const variables = {
    companyId: companyId,
    country: country,
  }

  const { data, error, loading, startPolling, stopPolling } = useQuery<
    CompanyRankingSettingsForCountryQuery,
    CompanyRankingSettingsForCountryQueryVariables
  >(COMPANY_RANKING_SETTINGS_FOR_COUNTRY, {
    variables: variables,
    fetchPolicy: 'network-only',
  })

  return { data, error, loading, startPolling, stopPolling }
}
